import { Api, isValidPositiveNumber, Log } from "../helpers";
import { SystemSettingsDto } from "../models";

export class SystemSettingsApi {
  static async getSystemSettings({
    companyId,
    siteId,
  }: {
    companyId: number;
    siteId?: number;
  }): Promise<SystemSettingsDto | undefined> {
    if (!isValidPositiveNumber(companyId)) {
      Log.warn("Invalid company id supplied to system settings fetch");
      return;
    }

    const requestUrl = isValidPositiveNumber(siteId)
      ? `/api/v1/core/c/${companyId}/systemSettings?siteId=${siteId}`
      : `/api/v1/core/c/${companyId}/systemSettings`;
    const response = await Api.get<SystemSettingsDto | undefined>(requestUrl);
    return response?.data;
  }
}
